import React from 'react';
import ConnectionHandle from './ConnectionHandle';
import DecisionHandles from './DecisionHandles';
import {
  getMilestoneLayoutDims,
  getMilestoneLabelSide,
  getMilestoneAnchor,
  getMilestoneJunctionCenter,
  MILESTONE_JUNCTION_SIZE,
} from '../../../utils/milestoneUtils';

/**
 * (+) handles for missions, milestones, and decision branches.
 * Hidden while a node is being dragged.
 */
export default function NodeConnectionHandles({
  handlesContainerRef,
  decisionHandlesContainerRef,
  isDragging,
  regularTasks,
  milestoneTasks,
  decisionTasks,
  nodePositions,
  nodeDimensions,
  canvasToScreen,
  onConnectionMouseDown,
  onBeforeMouseDown,
  onDecisionBranchMouseDown,
}) {
  const hidden = isDragging ? 'none' : undefined;

  return (
    <>
      <div ref={handlesContainerRef} className="handles-layer__handles" style={{ display: hidden }}>
        {regularTasks.map((task) => {
          const pos = nodePositions[task.id];
          const dims = nodeDimensions[task.id];
          if (!pos || !dims) return null;

          const screenPos = canvasToScreen(pos.x + dims.width / 2, pos.y + dims.height);
          const topScreenPos = canvasToScreen(pos.x + dims.width / 2, pos.y);

          return (
            <React.Fragment key={`handles-${task.id}`}>
              <ConnectionHandle
                task={task}
                screenPos={topScreenPos}
                edge="before"
                className="handles-layer__connection-handle--top"
                title="Insert a node before this mission"
                onMouseDown={(e) => onBeforeMouseDown(task, e)}
              />
              <ConnectionHandle
                task={task}
                screenPos={screenPos}
                onMouseDown={(e) => onConnectionMouseDown(task, e)}
              />
            </React.Fragment>
          );
        })}
        {milestoneTasks.map((task) => {
          const pos = nodePositions[task.id];
          if (!pos) return null;

          const dims = getMilestoneLayoutDims(nodeDimensions, task.id);
          const anchor = getMilestoneAnchor(task);
          const hostPos = anchor ? nodePositions[anchor.hostTaskId] : null;
          const hostDims = anchor ? nodeDimensions[anchor.hostTaskId] : null;
          const labelSide = getMilestoneLabelSide(pos, dims, hostPos, hostDims);
          const junction = getMilestoneJunctionCenter(pos, dims, labelSide);
          const screenPos = canvasToScreen(junction.x, junction.y + MILESTONE_JUNCTION_SIZE / 2);

          return (
            <ConnectionHandle
              key={`handle-${task.id}`}
              task={task}
              screenPos={screenPos}
              onMouseDown={(e) => onConnectionMouseDown(task, e)}
            />
          );
        })}
      </div>

      <div ref={decisionHandlesContainerRef} className="handles-layer__decision-handles" style={{ display: hidden }}>
        {decisionTasks.map((task) => {
          const pos = nodePositions[task.id];
          const dims = nodeDimensions[task.id];
          if (!pos || !dims) return null;

          const screenPos = canvasToScreen(pos.x + dims.width / 2, pos.y + dims.height);

          return (
            <DecisionHandles
              key={`decision-handles-${task.id}`}
              task={task}
              screenPos={screenPos}
              onDecisionBranchMouseDown={onDecisionBranchMouseDown}
            />
          );
        })}
      </div>
    </>
  );
}
